module.exports = __webpack_public_path__ + "img/ALL IN GAME 致力于给玩家带来极致的游戏体验.d28e0096.png";